export const getElementHeightByRef = (ref: HTMLElement) => {
  return ref ? parseInt(window.getComputedStyle(ref).height) : 0
}
